import React, { ReactChild } from "react";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Button, { Color, StylesProps } from "../../Form/Button";
import useStyles from "./styles";

export type ActionButtonProps = {
  variantCancel?: "text" | "outlined" | "contained" | undefined;
  dataCyCancel?: string;
  dataCySave?: string;
  dataCySavePublish?: string;
  dataCySaveAndSend?: string;
  onCancel?: () => void;
  onSave?: () => void;
  onSavePublish?: () => void;
  onSaveAndSend?: () => void;
  textSave?: React.ReactNode;
  textCancel?: React.ReactNode;
  textSavePublish?: string;
  textSaveAndSend?: string;
  customColorSave?: Color | StylesProps;
  customColorCancel?: Color;
  customColorSavePublish?: Color;
  customColorSaveAndSend?: Color;
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
  savePublishDisabled?: boolean;
  saveAndSendDisabled?: boolean;
  loading?: boolean;
  loadingSavePublish?: boolean;
  loadingSaveAndSend?: boolean;
  showCancelButton?: boolean;
  showSaveButton?: boolean;
  showSaveAndSendButton?: boolean;
  classesSave?: string;
  classesCancel?: string;

  dataCyInactive?: string;
  onInactive?: () => void;
  textInactive?: string;
  customColorInactive?: Color;
  inactiveDisabled?: boolean;
  loadingInactive?: boolean;
  classesInactive?: string;
  inactiveIcon?: ReactChild;
  saveIcon?: React.ReactNode;
};
const ActionButtons = (props: ActionButtonProps) => {
  const { t: translate } = useTranslation();

  const classes = useStyles();

  const {
    variantCancel = "text",
    dataCyCancel = "button-cancel",
    dataCySave = "button-save",
    dataCySavePublish = "button-save-publish",
    dataCySaveAndSend = "button-save-and-send",
    textSaveAndSend = `${translate("saveAndSendToCustomer")}`,
    textCancel = `${translate("cancel")}`,
    textSave = `${translate("update")}`,
    textSavePublish = `${translate("savePublishTask")}`,
    customColorSaveAndSend = Color.SUCCESS_OUTLINED,
    customColorSave = Color.SUCCESS,
    customColorCancel = Color.CANCEL,
    customColorSavePublish = Color.SUCCESS,
    onCancel,
    onSave,
    onSavePublish,
    onSaveAndSend,
    saveAndSendDisabled,
    cancelDisabled,
    saveDisabled,
    savePublishDisabled,
    loading = false,
    loadingSavePublish = false,
    loadingSaveAndSend = false,
    showSaveAndSendButton = false,
    showCancelButton = true,
    showSaveButton = true,
    classesSave,
    classesCancel,

    dataCyInactive = "button-inactive",
    onInactive,
    textInactive = translate("inactive"),
    customColorInactive = Color.ERROR,
    inactiveDisabled,
    loadingInactive,
    classesInactive,
    inactiveIcon,
  } = props;

  return (
    <div>
      <div className={classes.wrapper}>
        <Button
          style={{ visibility: onInactive ? "visible" : "hidden" }}
          data-cy={dataCyInactive}
          onClick={onInactive}
          customColor={customColorInactive}
          disabled={inactiveDisabled}
          loading={loadingInactive}
          className={classesInactive}
          startIcon={inactiveIcon}
        >
          {textInactive}
        </Button>
        <div>
          {onCancel && showCancelButton && (
            <Button
              variant={variantCancel}
              data-cy={dataCyCancel}
              onClick={onCancel}
              customColor={customColorCancel}
              disabled={cancelDisabled}
              className={classNames(classes.cancelText, classesCancel)}
            >
              {textCancel}
            </Button>
          )}
          {onSaveAndSend && showSaveAndSendButton && (
            <Button
              data-cy={dataCySaveAndSend}
              onClick={onSaveAndSend}
              customColor={customColorSaveAndSend}
              disabled={saveAndSendDisabled}
              loading={loadingSaveAndSend}
            >
              {textSaveAndSend}
            </Button>
          )}
          {onSave && showSaveButton && (
            <Button
              data-cy={dataCySave}
              onClick={onSave}
              customColor={customColorSave}
              disabled={saveDisabled}
              loading={loading}
              className={classNames(classes.rightButton, classesSave)}
              {...(props.saveIcon ? { startIcon: props.saveIcon } : {})}
            >
              {textSave}
            </Button>
          )}
          {onSavePublish && (
            <Button
              data-cy={dataCySavePublish}
              onClick={onSavePublish}
              customColor={customColorSavePublish}
              disabled={savePublishDisabled}
              loading={loadingSavePublish}
              className={classes.rightButton}
            >
              {textSavePublish}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActionButtons;
